import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadStateService {

  constructor() { }
  private uploadingSubject = new BehaviorSubject<boolean>(false);

  uploading$ = this.uploadingSubject.asObservable();

  setUploading(state: boolean) {
    this.uploadingSubject.next(state);
  }
}
